
export default {
  props: {
    sort: {
      type: String,
      required: true,
    },

    dimensions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeTags: [],
    }
  },

  watch: {
    activeTags() {
      this.$emit('update', this.activeTags)
    },
  },

  methods: {
    toggleTag(dimension) {
      this.activeTags.includes(dimension)
        ? (this.activeTags = this.activeTags.filter(
            (item) => item !== dimension
          ))
        : this.activeTags.push(dimension)
    },
  },
}
